import React, { useEffect, useState } from "react";

import styles from "./Filter.module.css";

import ShowAndHide from "common-ui-components/components/show-and-hide/ShowAndHide";
import { useTableManagerContext } from "../../TableManagerContext";
import Separator from "common-ui-components/components/Separator";
import { buildFilterSection } from "./FilterConfigBuilder";
import close from "./../../../icons/blue-close.svg";
import Button from "common-ui-components/components/button";

const FilterContainer = ({
    setFilterOpen,

    filterConfig, //config for comprehensive filter
    comprehensiveFilter,
    setComprehensiveFilter,
    setAppliedFilters,

    dynamicFilterConfig, //config for dynamic filter
    dynamicFilter,
    setDynamicFilter,
    setAppliedDynamicFilters,

    setFiltersForSaving,

    filterComponents, //additional filter components to be rendered in the filter container
    setAppliedCustomFilter, //function to set the applied custom filter state
    }) => {
        
    const { filter, setFilter } = useTableManagerContext();
    const totalFilterConfigs=[...filterConfig, ...dynamicFilterConfig];

    //stores the text for selected filter tiles
    const [filterItems,setFilterItems]=useState([]);
    const getCount=(search)=>{
        const count = filterItems.filter(item => item.includes(search)).length;
        return count
    }

    //stores the all filter headings
    const totalFilters=totalFilterConfigs.map((column)=>column.heading)
    // stores the filter headings as per the search
    const [filtersToView,setFiltersToView]=useState(totalFilters);
    // sores the mapping of heading and column accessor of a filter
    const mapping = totalFilterConfigs.reduce((acc, item) => {
        acc[item.column] = item.heading;
        return acc;
    }, {});

    const excludeDynamicFilter = () =>filter.filter(
        (f) => !dynamicFilterConfig?.map((df) => df.column).includes(f.column)
    );

    const handleReset = () => {
        filterComponents.forEach((item) => {
            if (item.valueRef) {
                item.valueRef.current = "";
            }
        });
        const customColumns = new Set(filterComponents.map((fc) => fc.column));
        setFilter(excludeDynamicFilter()
            .filter((f) =>
                !filterConfig.map((cf) => cf.column).includes(f.column) &&
                !customColumns.has(f.column)
            )
        );

        setComprehensiveFilter([]);
        setAppliedFilters([]);
        setFiltersForSaving((prev) => ({ ...prev, comprehensive_filters: [] }));

        setAppliedCustomFilter([]);

        setDynamicFilter([]);
        setAppliedDynamicFilters([]);
        setFiltersForSaving((prev) => ({ ...prev, dynamic_filters: [] }));
    };

    const handleApply = () => {
        const customFilters = filterComponents
            .filter(
                (item) =>
                    item.valueRef?.current !== "" &&
                    item.valueRef?.current !== null &&
                    item.valueRef?.current !== undefined
            )
            .map((item) => ({
                column: item.column,
                filterValue: [item.valueRef.current],
            }));
        const customColumns = new Set(filterComponents.map((fc) => fc.column));
        setFilter(excludeDynamicFilter()
            .filter((f) =>
                !filterConfig.map((cf) => cf.column).includes(f.column) &&
                !customColumns.has(f.column)
            )
            .concat(comprehensiveFilter)
            .concat(customFilters)
            .concat(dynamicFilter)
        );

        setAppliedCustomFilter(customFilters);

        setAppliedFilters(comprehensiveFilter);
        if (filterConfig) 
        {
            setFiltersForSaving((prev) => ({
                ...prev,
                comprehensive_filters: buildFilterSection(comprehensiveFilter, filterConfig)
            }));
        }

        setAppliedDynamicFilters(dynamicFilter);
        if (dynamicFilterConfig) {
            setFiltersForSaving((prev) => ({
                ...prev,
                dynamic_filters: buildFilterSection(dynamicFilter, dynamicFilterConfig)
            }));
        }
        
        setFilterOpen(false);
    };

    //remove filter tiles
    const handleRemoveFilterItem=(itemToRemoved)=>{
        const updatedFilters = comprehensiveFilter
        .map(({ column, filterValue }) => {
            const prefix = `${mapping[column]} : `;
            if (!itemToRemoved.startsWith(prefix)) {
                return { column, filterValue };
            }
            const valueToRemove = itemToRemoved.slice(prefix.length);
            return {
                column,
                filterValue: filterValue.filter(
                    (value) => value !== valueToRemove
                ),
            };
        })
        .filter(({ filterValue }) => filterValue.length > 0);
        setComprehensiveFilter(updatedFilters);
    }
    //search filters
    const handleSearch=(search)=>{
        const filteredFilters = totalFilters.filter(
            (item) =>item.toLowerCase().includes(search.toLowerCase())
        );
        setFiltersToView(filteredFilters);
    }
    const formatHeading = (text) => {
        return text.replace(/([A-Z])/g, " $1").replace(/^./, (char) => char.toUpperCase());
    };
    useEffect(()=>{
        const items = [...comprehensiveFilter,...dynamicFilter].flatMap(({ column, filterValue }) => filterValue.map((value) => `${mapping[column]} : ${value}`));
        setFilterItems(items);
    },[comprehensiveFilter,dynamicFilter])

    //handles filter selection
    const handleFilterChange = (e, column, type, value) => {
        const { checked } = e.target;
        const existing = comprehensiveFilter.find((f) => f.column === column);
        const others = comprehensiveFilter.filter((f) => f.column !== column);
        let newFilter = [...others];

        if (type === "single") {
            if (checked) {
                newFilter.push({
                column,
                filterValue: value,
                });
            }
        }

        if (type === "multiple") 
        {
            if (checked) {
                newFilter.push({
                    column,
                    filterValue: [...(existing?.filterValue || []), value],
                });
            } 
            else 
            {
                if (existing) {
                    const updatedValues = existing.filterValue.filter((v) => v !== value);
                    if (updatedValues.length > 0) {
                        newFilter.push({ column, filterValue: updatedValues });
                    }
                }
            }
        }
        setComprehensiveFilter(newFilter);
    };

    const handleDynamicFilterChange = (e, column, type, value) => {
        const { checked } = e.target;
        const existing = dynamicFilter.find((f) => f.column === column);
        const others = dynamicFilter.filter((f) => f.column !== column);
        let newFilter = [...others];

        if (type === "single") 
        {
            if (checked) 
            {
                newFilter.push({
                column,
                filterValue: value,
                });
            }
        }

        if (type === "multiple") 
        {
            if (checked) {
                newFilter.push({
                column,
                filterValue: [...(existing?.filterValue || []), value],
                });
            } else {
                if (existing) {
                const updatedValues = existing.filterValue.filter(
                    (v) => v !== value,
                );

                if (updatedValues.length > 0) {
                    newFilter.push({
                    column,
                    filterValue: updatedValues,
                    });
                }
                }
            }
        }

        setDynamicFilter(newFilter);
    };

    return (
        <div className={styles.FilterContainer}>
            <h3 className={styles.filterHeading}>Filter</h3>
            <div className={styles.search}>
                <div className={styles.searchContainer}>
                    <span className={styles.searchIcon}>⌕</span>
                    <input
                        onChange={(e)=>handleSearch(e.target.value)}
                        style={{width:"100%",borderRadius:"7px",fontSize:"12px",padding:"0.5rem",paddingLeft:"1.7rem"}}
                        placeholder="Search filters eg : Platform"
                    />
                </div>
            </div>
            {filterItems!==0 ?
                <div className={styles.chipContainer}>
                    {filterItems.map((item)=>(
                        <div
                            key={item}
                            className={styles.filterChip}
                        >
                            <span>{item}</span>
                            <img 
                                src={close} 
                                className={styles.closeButton}
                                onClick={() => handleRemoveFilterItem(item)}
                            />
                        </div>
                    ))}
                </div> : null
            }
            <Separator />
            <div className={styles.filters}>
                {filterConfig.map((filterContent, index) => (
                    filtersToView.includes(filterContent.heading) && (
                        <FilterContent
                            key={filterContent.heading}
                            heading={
                                filterContent.heading +
                                (getCount(filterContent.heading)>5
                                    ? `  ( ${getCount(filterContent.heading)} )`
                                    : "")
                            }
                            filter={comprehensiveFilter}
                            lastFilter={filterConfig.length - 1 === index}
                            {...{ filterContent, handleFilterChange }}
                        />
                    )
                ))}
                {dynamicFilterConfig?.map((filterContent, index) => (
                    <FilterContent
                        key={filterContent.heading}
                        heading={
                            filterContent.heading +
                            (getCount(filterContent.heading)>5
                                ? `  ( ${getCount(filterContent.heading)} )`
                                : "")
                        }
                        filter={dynamicFilter}
                        lastFilter={dynamicFilterConfig.length - 1 === index}
                        {...{filterContent, handleFilterChange: handleDynamicFilterChange }}
                    />
                ))}
                {filterComponents.length > 0 && filterComponents.map((component, index) => (
                    <div className={styles.FilterContent}>
                        <ShowAndHide
                            key={`filter-component-${index}`}
                            containerProps={{ style: { boxShadow: "none" } }}
                            headerText={component.heading}
                            headerProps={{ className: styles.filterHeaderComponent }}
                            iconProps={{ width: 12, height: 12 }}
                            initiallyOpen
                        >
                            {component.Component}
                        </ShowAndHide>
                    </div>)
                )}
            </div>
            <Separator />
            <div className={styles.filterControlButtons}>
                <Button
                    className={[styles.filterControlButton, styles.resetButton].join(" ")}
                    onClick={handleReset}
                >
                    Reset
                </Button>
                <Button
                    onClick={handleApply}
                    variant={"primary"}
                >
                    Apply 
                    {filterItems.length!==0 && <Count count={filterItems.length}/>}
                </Button>
            </div>
        </div>);
    };

    const Count=({count})=>{
        return(
            <span style={{
                fontSize:"11px",
                width:"20px",
                height:"20px",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                backgroundColor:"#2247BE",
                borderRadius:"50%"
            }}>
                {count}
            </span> 
        )
    }

    const FilterContent = ({
        filter,
        heading,
        filterContent,
        handleFilterChange,
        lastFilter,
    }) => {
    return (
        <div className={styles.FilterContent}>
            <ShowAndHide
                containerProps={{ style: { boxShadow: "none" } }}
                headerText={heading}
                headerProps={{ className: styles.filterHeaderComponent }}
                iconProps={{ width: 12, height: 12 }}
                initiallyOpen
            >
                <div className={styles.filterOptions}>
                    {filterContent.options.map(({ value, label }) => {
                        const optionId = `${filterContent.heading}-${filterContent.column}-${label}-${value}`;
                        const getChecked = () => {
                            const newFilter = filter.filter(
                                (f) => f.column === filterContent.column,
                            );
                            if (!newFilter.length) return false;
                            if (filterContent.type === "single")
                                return newFilter[0].filterValue === value;
                            return (
                                Array.isArray(newFilter[0].filterValue) &&
                                newFilter[0].filterValue.includes(value)
                            );
                        };
                        const checked = getChecked();
                        return (
                            <div key={optionId} className={styles.filterOption}>
                                <input
                                    type={filterContent.type === "single" ? "radio" : "checkbox"}
                                    id={optionId}
                                    name={filterContent.heading}
                                    value={value}
                                    checked={checked}
                                    onClick={() => {
                                        if (filterContent.type === "single" && checked) {
                                            handleFilterChange(
                                                { target: { checked: false } },
                                                filterContent.column,
                                                filterContent.type,
                                                value,
                                            );
                                        }
                                    }}
                                    onChange={(e) =>
                                        handleFilterChange(
                                        e,
                                        filterContent.column,
                                        filterContent.type,
                                        value,
                                        )
                                    }
                                />
                                <label htmlFor={optionId}>{label}</label>
                            </div>
                        );
                    })}
                </div>
            </ShowAndHide>
        </div>
    );
};

export default FilterContainer;